import { render } from "./GameRowSlider.vue?vue&type=template&id=4c463acb"
import script from "./GameRowSlider.vue?vue&type=script&lang=js"
export * from "./GameRowSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__